import {h, Component} from 'preact';
import authContainer from '../tags/auth-container';
import UserAuth from '../../services/userAuth';

export class Verification extends Component {
    constructor() {
        super();
        this.state = {
            optionsStatus: false,
            resendLoading: false,
            resendStatus: '',
            offlineCode: '',
            signInButtonLoading: false,
            verificationError: ''
        }
    }

    componentDidMount() {
        document.title = 'Sign in verification | workplace_';
        this.props.pollingTimer();
        this.setState({verificationError: this.props.verificationError});
    }

    componentDidUpdate(prevProps) {
        if (this.props.verificationError !== prevProps.verificationError) {
            this.setState({verificationError: this.props.verificationError});
        }
    }

    toggleOfflineInput = () => {
        this.setState({optionsStatus: !this.state.optionsStatus});
    };

    resendVerification = () => {
        this.setState({ resendLoading: true, resendStatus: '' });
        UserAuth.resendVerification()
            .then(() => {
                setTimeout(() => this.setState({ resendLoading: false,  resendStatus: 'Sign-in request resent to your mobile app.' }), 5000);
            }, error => {
                console.log(error.response.data);
            });
    };

    submitOfflineCode = () => {
        this.setState({signInButtonLoading: true, verificationError: ''});
        const offlineCode = this.state.offlineCode.replace('-', '');
        UserAuth.submitSigninVerification(offlineCode)
            .then(() => {
                this.setState({verificationError: ''});
             }, error => {
                this.setState({signInButtonLoading: false, verificationError: error.response.data});
            })
    };

    backToLoginAndSignOut = () => {
        UserAuth.logout()
            .then(() => {
                this.props.history.push({
                    pathname: '/',
                    search: location.search
                })
            }, error => {
                console.log(error);
            });
    };

    onKeypress = e => {
        const keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            e.preventDefault();
            this.submitOfflineCode();
        }
    };

    onOfflineCodeUp = e => {
        const keyCode = e.keyCode || e.which;
        const keyValue = e.key;
        if (!isNaN(keyValue) || keyCode === 109 || keyCode === 189 || keyCode === 8 || keyCode === 46) {
            let offlineCode = e.target.value.slice(0,9);
            if (offlineCode.match(/^\d\d\d\d\d/)) {
                offlineCode = offlineCode.slice(0,4) + '-' + offlineCode.slice(4,offlineCode.length);
            }
            if (keyCode === 109 || keyCode === 189) {
                if (!offlineCode.match(/^\d\d\d\d-$/)) {
                    offlineCode = this.state.offlineCode;
                }
            }
            this.setState({ offlineCode });
        } else {
            this.setState({ offlineCode: this.state.offlineCode });
        }
    };

    render({renderHelpLink}, {optionsStatus, resendLoading, resendStatus, offlineCode, signInButtonLoading, verificationError}) {
        return(
            <section class='auth-modal-container verification mobile-verification'>
                <h3>Check your phone</h3>
                <div class='form clearfix verify'>
                    <div class='mobile-loader' />
                    Verify sign-in on your phone.
                    <a onClick={this.toggleOfflineInput} class='button button-default pull-right button-small offlineInputBtn'>
                        {optionsStatus ? 'Close' : 'Skip'}
                    </a>
                </div>

                <div class={`form resend clearfix ${optionsStatus ? 'active' : ''}`}>
                    <div class='content clearfix'>
                        <div>
                            <span>No notification received?</span>
                            <a class={`button button-secondary pull-right button-small resendVerificationBtn ${resendLoading ? 'loading disabled' : ''}`}
                            onClick={this.resendVerification}>Resend</a></div>
                        <p class='resend-status'>{resendStatus}</p>
                    </div>
                </div>

                <div class={`form offline ${optionsStatus ? 'active' : ''}`}>
                    <div class='content'>
                        <form>
                            <p><span>No service?</span> Check the mobile app for the offline code:</p>
                            <div class='form-group clearfix'>
                                <label htmlFor='offline-code'>Offline code:</label>
                                <span class='svg-icon-plane'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17">
                                        <path fill="#1F88F9" d="M9.183.155c.917-.016 1.223 1.08 1.223 1.08l.085 4.91 7.027 3.74s.95.388.585 1.42c-.364 1.03-1.596.552-1.596.552L10.224 9.82l.062 3.581 1.757 1.322.02 1.097s-.301.29-.48.293c-.178.004-1.95-.705-2.51-.695v-.006c-.682.106-2.123.725-2.286.722-.178-.003-.479-.293-.479-.293l.02-1.098 1.887-1.541-.068-3.364-6.283 2.037s-1.232.479-1.597-.553c-.364-1.032.586-1.42.586-1.42L7.88 6.16l.086-4.912S8.265.138 9.183.154z"/>
                                    </svg>
                                </span>
                                <input name='offlineCode'
                                       class='form-control'
                                       id='offline-code'
                                       required
                                       type='text'
                                       placeholder=''
                                       value={offlineCode}
                                       onKeyPress={this.onKeypress}
                                       onKeyUp={this.onOfflineCodeUp}
                                />
                                <a class={`button button-secondary pull-right button-small signInBtn ${signInButtonLoading ? 'loading disabled' : ''}`}
                                   onClick={this.submitOfflineCode}>Sign in</a>
                            </div>
                            <p class='login-error'>{verificationError} &nbsp;</p>
                        </form>
                    </div>
                </div>

                <div class={`form offline links ${optionsStatus ? 'active' : ''}`}>
                    <div class='content clearfix'>
                        {renderHelpLink('pull-left', false)}
                        <a onClick={this.backToLoginAndSignOut} class='button-secondary button-small button pull-right logoutBtn'>Sign out</a>
                    </div>
                </div>
            </section>
        )
    }
}

export default authContainer(Verification);




// WEBPACK FOOTER //
// ./src/scripts/views/two-factor/verification.js